module.exports = __webpack_public_path__ + "img/häst.068255e5.png";